import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { deployRollupInitialState } from '../../../rollupFormInitialState';
import { IDeployRollupFormPayload } from '../../../types/rollupFormTypes';

export const rollupDeploySlice = createSlice({
  name: 'rollupDeploy',
  initialState: deployRollupInitialState,
  reducers: {
    updateFormData: (
      state,
      action: PayloadAction<IDeployRollupFormPayload>,
    ) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    resetFormData: () => deployRollupInitialState,
  },
});

export const { updateFormData, resetFormData } = rollupDeploySlice.actions;
